import { InputNumber } from "antd";
import TextField2 from "../textfields/TextField2";
import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";
import FacturePaymentVisualisateur from "./FacturePaymentVisualisateur";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useSnackbar } from "notistack";
import { Switch, useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import { useState } from "react";
import Modal1 from "../modals/Modal1";
import Payment from "./PaymentModal";
import createDocApi from "../api/database/createDocApi";
import { folder } from "jszip";
import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";
import { addActivityLog } from "../config/OnlineStatus";
import { EasySwitch } from "../textfields/EasySwitch";
import WarningButton from "../buttons/WarningButton";
import UploadRapportPayment from "../api/upload/UploadRapportPayment";
import PaymentRapportVisualisateur from "./PaymentRapportVisualisateur";
import { getFlutterTime } from "../models/DataFunctions";
import UploadFacturePayment from "../api/upload/UploadFacturePayment";
import TextField2T from "../textfields/TextField2T";
import { EditableInfoCell } from "../pages/folder_pages/folder_sidebar/FolderInformationSection";
import updateDocApi from "../api/database/updateDocApi";
import Tippy from "@tippyjs/react";
import PaymentModal from "./PaymentModal";
import getTemporaryUrl from "../api/getTemporaryUrl";
import getTemporaryUrlV2 from "../api/getTemporaryUrlV2";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import ReglementFolderDevis from "./ReglementFolderDevis";
import moment from "moment";

const ReglementFolder = ({
  orgData,
  userData,
  folderData,
  clientData,
  reglement,
  setReglement,
  payments,
  setPayments,

  handleUpdateReglement,
  handleFetchData,

  loadingTransfer,
  setLoadingTransfer,
  transferFiles,
  dropped_exists,
  navigateWorkspace,
  handleSetReglementDone,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [deleteOpen, setDeleteOpen] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [payment_open, setPaymentOpen] = useState(null);
  const theme = useTheme();
  const handleSetPaid = async (index) => {
    let history_events = payments[index].history_events || [];
    history_events.push({
      date: getFlutterTime(),
      name: "Paiement passé en payé",
    });
    await updateDocApi(
      payments[index].ref,
      {
        state: "paid",
        paid_date: getFlutterTime(),
        history_events: history_events,
        initiation_seconds: payments[index].initiation_seconds? payments[index].initiation_seconds : moment().unix(),
      },
      prefix
    );

    let new_payments = [...payments];
    new_payments[index].state = "paid";
    let one_not_paid =
      payments.filter(
        (payment) => payment.state === "initiated" || payment.state === "opened"
      ).length > 0;
    await updateDocDataFieldApi(
      folderData.ref,
      "reglement.state",
      one_not_paid ? "wait" : "done",
      prefix
    );

    await addActivityLog(
      "Paiement indiqué comme payé",
      folderData.ref,
      orgData.id,
      userData.id,
      "payment_marqued_as_paid",
      prefix
    );
    handleClickVariant("Le paiement a été indiqué comme payé", "success");
    handleFetchData();
  };

  const handleSavePayment = async (index) => {
    await updateDocDataFieldApi(
      payments[index].ref,
      "amount",
      payments[index].amount,
      prefix
    );
    await updateDocDataFieldApi(
      payments[index].ref,
      "unlock_reports",
      payments[index].unlock_reports ? true : false,
      prefix
    );
    await addActivityLog(
      "Informations de paiement enregistrées",
      folderData.ref,
      orgData.id,
      userData.id,
      "payment_info_saved",
      prefix
    );
    handleFetchData();
    handleClickVariant("Paiement enregistré", "success");
  };
  const [loadingInvoice, setLoadingInvoice] = useState(false);

  const handleLoadInvoice = async (invoice) => {
    if (invoice.file.id) {
      setLoadingInvoice(invoice.file.id);
      const token = await getOrRefreshFirebaseToken();
      let refreshed_url = await getTemporaryUrlV2(
        invoice.file.id,
        token,
        prefix
      );
      if (refreshed_url) {
        window.open(refreshed_url, "_blank");
      } else {
        handleClickVariant("Impossible de charger le fichier", "error");
      }
      setLoadingInvoice(false);
    }
  };

  const handleRemoveInvoice = async (invoice) => {
    setLoadingInvoice(invoice.file.id);
    let new_invoices = folderData.invoices.filter(
      (inv) => inv.file?.id !== invoice.file?.id
    );
    await updateDocDataFieldApi(
      folderData.ref,
      "invoices",
      new_invoices,
      prefix
    );
    await addActivityLog(
      "Devis supprimé",
      folderData.ref,
      orgData.id,
      userData.id,
      "invoice_deleted",
      prefix
    );

    handleFetchData();
    handleClickVariant("Devis supprimé", "success");
    setLoadingInvoice(false);
  };

  const handleDeletePayment = async (index) => {
    if (payments[index].paid === true) {
      handleClickVariant(
        "Impossible de supprimer un paiement déjà payé",
        "error"
      );
      return;
    }
    // if only one payment, delletion is not allowed
    if (payments.length === 1) {
      handleClickVariant(
        "Impossible de supprimer si c'est le seul paiement",
        "error"
      );
      return;
    }
    let new_payments = payments
      .map((pay) => pay.ref)
      .filter((_, i) => i !== index);
    await updateDocDataFieldApi(
      folderData.ref,
      "reglement.payments",
      new_payments,
      prefix
    );
    let one_not_paid =
      new_payments.filter(
        (payment) => payment.state === "initiated" || payment.state === "opened"
      ).length > 0;
    await updateDocDataFieldApi(
      folderData.ref,
      "reglement.state",
      one_not_paid ? "wait" : "done",
      prefix
    );
    await addActivityLog(
      "Paiement supprimé",
      folderData.ref,
      orgData.id,
      userData.id,
      "payment_deleted",
      prefix
    );
    await deleteDocApi(payments[index].ref, prefix);
    setDeleteOpen(null);
    handleFetchData();
    handleClickVariant("Paiement supprimé", "success");
  };

  const handleTransferFiles = async (docId) => {
    setLoadingTransfer(docId);
    await transferFiles(docId);
    setLoadingTransfer(null);
  };

  const handleSync = async (index) => {
    await updateDocApi(
      payments[index].ref,
      {
        title: payments[index].title,
      },
      prefix
    );
    handleClickVariant("Paiement synchronisé", "success");
  };

  const handleAddPayment = async () => {
    let data = {
      master_id: folderData.master_id,
      amount: 0,
      facture_file: null,
      folder_ref: folderData.ref,
      reglement_infos: reglement.infos,
      nom: folderData.nom,
      paid: false,
      client_type: folderData.client_type,
      creation_date: getFlutterTime(),
      history_events: [
        {
          date: getFlutterTime(),
          name: "Création du paiement dans le dossier",
        },
      ],
    };
    let new_payment = await createDocApi("payment", data, prefix);

    let payments = folderData.reglement?.payments
      ? folderData.reglement.payments
      : [];
    payments.push(new_payment.ref);
    await addActivityLog(
      "Paiement ajouté",
      folderData.ref,
      orgData.id,
      userData.id,
      "payment_added",
      prefix
    );
    await updateDocDataFieldApi(
      folderData.ref,
      "reglement.payments",
      payments,
      prefix
    );
    handleFetchData();
    handleClickVariant("Paiement ajouté", "success");
  };

  const handleSetUnPaid = async (index) => {
    let history_events = payments[index].history_events || [];
    history_events.push({
      date: getFlutterTime(),
      name: "Paiement passé en non payé",
    });
    await updateDocApi(
      payments[index].ref,
      {
        state: "",
        paid_date: null,
        history_events: history_events,
      },

      prefix
    );

    await updateDocDataFieldApi(
      folderData.ref,
      "reglement.state",
      "wait",
      prefix
    );
    await addActivityLog(
      "Paiement indiqué comme non payé",
      folderData.ref,
      orgData.id,
      userData.id,
      "payment_marqued_as_unpaid",
      prefix
    );
    handleFetchData();
    handleClickVariant("Le paiement a été indiqué comme non payé", "success");
  };
  return (
    <div className="flex flex-col h-fit gap-2 justify-end items-start">
      <div className="flex flex-row h-fit gap-2 justify-end items-start w-full">
        {(deleteOpen != null || payment_open !== null) && (
          <div className="absolute w-screen h-screen  z-10">
            <Modal1
              isOpen={deleteOpen != null}
              onClose={() => setDeleteOpen(null)}
            >
              <div className=" flex flex-col bg-white rounded-xl p-4">
                <div className="text-h2">
                  Voulez-vous vraiment supprimer cet élément ?
                </div>
                <div className="text-h3 text-shadow_50 my-4">
                  Cette action est irréversible. Elle entraîne la suppression
                  définitive de ces éléments.
                </div>
                <div className="text-h3 text-shadow_50 ">- Facture déposée</div>
                <div className="text-h3 text-shadow_50 ">
                  - Rapports déposés
                </div>
                <div className="text-h3 text-shadow_50 ">- Prix déposés</div>

                {!loadingDelete && (
                  <div className="flex flex-row justify-end gap-2 ">
                    <SecondaryButton onClick={() => setDeleteOpen(null)}>
                      Annuler
                    </SecondaryButton>
                    <WarningButton
                      onClick={() => handleDeletePayment(deleteOpen)}
                    >
                      Supprimer
                    </WarningButton>
                  </div>
                )}
                {loadingDelete && <SmallSpinner></SmallSpinner>}
              </div>
            </Modal1>
            <Modal1
              isOpen={payment_open !== null}
              onClose={() => setPaymentOpen(null)}
            >
              <PaymentModal
                orgData={orgData}
                folder={folderData}
                userData={userData}
                paymentData={payments[payment_open]}
                index={payment_open}
                onClose={() => setPaymentOpen(null)}
                onUpdate={handleFetchData}
                navigateWorkspace={navigateWorkspace}
              ></PaymentModal>
            </Modal1>
          </div>
        )}

        <div className="flex flex-col text-h3 border-1 h-fit border-shadow_10  w-c400 gap-1 rounded-xl p-2">
          Informations règlement
          <TextField2T
            transparent={false}
            mandatory={true}
            value={reglement?.infos?.email}
            mandatory_characters={["@", "."]}
            onChange={(e) => {
              setReglement({
                ...reglement,
                // i want lowercase email
                infos: {
                  ...reglement?.infos,
                  // format email to lowercase
                  email: e.target.value.trim().toLowerCase(),
                },
              });
            }}
            label="Email du particulier"
          />
          <TextField2T
            transparent={false}
            mandatory={true}
            value={reglement?.infos?.phone}
            type="phone"
            onChange={(e) => {
              setReglement({
                ...reglement,

                infos: {
                  ...reglement?.infos,
                  // format phone number to 06 00 00 00 00
                  phone: e.target.value,
                },
              });
            }}
            label="Téléphone du particulier"
          />
          <TextField2T
            transparent={false}
            mandatory={true}
            value={reglement?.infos?.first_name}
            onChange={(e) => {
              setReglement({
                ...reglement,

                infos: {
                  ...reglement?.infos,
                  // format phone number to 06 00 00 00 00
                  first_name: e.target.value,
                },
              });
            }}
            label="Prénom du particulier"
          />
          <TextField2T
            transparent={false}
            mandatory={true}
            value={reglement?.infos?.name}
            onChange={(e) => {
              setReglement({
                ...reglement,
                infos: {
                  ...reglement?.infos,
                  name: e.target.value,
                },
              });
            }}
            label="Nom du particulier"
          />
          <TextField2T
            transparent={false}
            mandatory={true}
            value={reglement?.infos?.city}
            onChange={(e) => {
              setReglement({
                ...reglement,
                infos: {
                  ...reglement?.infos,
                  city: e.target.value,
                },
              });
            }}
            label="Ville du maître d'ouvrage"
          />
          <TextField2T
            transparent={false}
            mandatory={true}
            value={reglement?.infos?.postal}
            onChange={(e) => {
              setReglement({
                ...reglement,
                infos: {
                  ...reglement?.infos,
                  postal: e.target.value,
                },
              });
            }}
            label="Code postal du maître d'ouvrage"
          />
          <TextField2T
            transparent={false}
            value={reglement?.infos?.address}
            mandatory={true}
            onChange={(e) => {
              setReglement({
                ...reglement,
                infos: {
                  ...reglement?.infos,
                  address: e.target.value,
                },
              });
            }}
            label="Adresse du maître d'ouvrage"
          />
          <div className="flex flex-row justify-end w-full gap-2">
            <PrimaryButton
              className="w-fit h-fit"
              onClick={handleUpdateReglement}
              disabled={
                reglement?.infos?.email ===
                  folderData.reglement?.infos?.email &&
                reglement?.infos?.phone ===
                  folderData.reglement?.infos?.phone &&
                reglement?.infos?.first_name ===
                  folderData.reglement?.infos?.first_name &&
                reglement?.infos?.name === folderData.reglement?.infos?.name &&
                reglement?.infos?.city === folderData.reglement?.infos?.city &&
                reglement?.infos?.postal ===
                  folderData.reglement?.infos?.postal &&
                reglement?.infos?.address ===
                  folderData.reglement?.infos?.address
              }
            >
              Enregistrer
            </PrimaryButton>{" "}
          </div>
        </div>
        <div className="flex flex-col gap-1 h-fit flex-grow">
          <ReglementFolderDevis
            orgData={orgData}
            userData={userData}
            folderData={folderData}
            prefix={prefix}
            handleFetchData={handleFetchData}
            loadingTransfer={loadingTransfer}
            setLoadingTransfer={setLoadingTransfer}
            transferFiles={transferFiles}
            dropped_exists={dropped_exists}
            navigateWorkspace={navigateWorkspace}
          ></ReglementFolderDevis>
        </div>
      </div>
      <div className="border-1 border-shadow_10 h-fit rounded-lg flex flex-col p-1 gap-1 w-full">
        <div className="flex flex-col gap-1 text-h3 text-black h-fit p-1">
          Paiements
          <div className="flex flex-col gap-2 p-1">
            {payments?.map((payment, index) => (
              <div
                key={index}
                className={`flex flex-col gap-1 relative border-1 text-h2 ${["initiated", "opened", "pending"].includes(payments[index]?.state) ? "bg-orange-50 border-orange-400 " : payments[index]?.state === "paid" ? "bg-teal-50 border-teal-300 " : payments[index]?.state === "error" ? "bg-red-50 border-red-300 " : "bg-slate-50 border-slate-300"}  rounded-xl p-2`}
              >
                <div className="flex flex-row gap-2 justify-between mb-1 text-indigo-500 ">
                  <EditableInfoCell
                    data={
                      payments[index].title !== null &&
                      payments[index].title !== undefined
                        ? payments[index].title
                        : "emplacement de paiement " + (index + 1).toString()
                    }
                    onChangeData={(e) => {
                      setPayments((prev) => {
                        let new_payments = [...prev];
                        new_payments[index].title = e.target.value;
                        return new_payments;
                      });
                    }}
                    orgData={orgData}
                    folderData={folderData}
                    handleSync={() => handleSync(index)}
                  ></EditableInfoCell>
                  <div className=" w-fit text-h3 text-shadow_10 ">
                    {payments[index]?.id}
                  </div>
                  {payments[index]?.master_id && (
                    <div
                      onClick={() =>
                        navigateWorkspace("/payment/" + payments[index]?.id)
                      }
                      className="cursor-pointer flex hover:shadow-md hover:border-neutral-200 hover:scale-x-105 duration-300 transition-all flex-row gap-4 bg-wshadow_50 p-2 border-1 border-shadow_10 rounded-xl text-h3 text-black"
                    >
                      Ouvrir <Icon1 icon_name="open" size={18}></Icon1>
                    </div>
                  )}
                </div>
                <div className="flex flex-row gap-4 ">
                  <div className="w-1/2 flex flex-col gap-2   ">
                    <div className="flex flex-row gap-2">
                      <TextField2T
                        type="euros"
                        value={payments[index].amount}
                        disabled={payments[index]?.state === "paid"}
                        onChange={(e) => {
                          setPayments((prev) => {
                            let new_payments = [...prev];
                            new_payments[index].amount = parseFloat(
                              e.target.value
                            );
                            return new_payments;
                          });
                        }}
                        className="w-c150"
                        label="Montant"
                        onFocusLost={() =>
                          payments[index]?.state !== "paid" &&
                          handleSavePayment(index)
                        }
                      />
                      {payments[index]?.state !== "paid" && (
                        <SecondaryButton
                          className="w-fit h-fit"
                          onClick={() => handleSetPaid(index)}
                        >
                          Passer en déjà payé
                        </SecondaryButton>
                      )}
                      {payments[index]?.state === "paid" && (
                        <SecondaryButton
                          className="w-fit h-fit"
                          onClick={() => handleSetUnPaid(index)}
                        >
                          Passer en non payé
                        </SecondaryButton>
                      )}{" "}
                    </div>
                    <div className=" border rounded-lg p-2">
                      <div className="text-h3 text-shadow_50 ">
                        Facture pour particulier
                      </div>
                      {dropped_exists && (
                        <SecondaryButton
                          sx={{
                            backgroundColor: theme.palette.chart.line_blue,
                            color: theme.palette.forever.white,
                          }}
                          className="h-fit w-fit inset-0 shimmer rounded-2xl "
                          onClick={() =>
                            handleTransferFiles("facture#" + index)
                          }
                          disabled={
                            loadingTransfer !== undefined &&
                            loadingTransfer !== null
                          }
                        >
                          <div>
                            <div className="flex flex-row gap-1 items-center">
                              {loadingTransfer === "facture#" + index
                                ? "Transfert en cours ..."
                                : "Transférer ici"}
                              <SmallSpinner
                                loading={loadingTransfer === "facture#" + index}
                                margin={0}
                                size={20}
                              />
                            </div>
                          </div>
                        </SecondaryButton>
                      )}
                      <div className="flex flex-row gap-2">
                        <div className="flex w-8 h-fit">
                          <UploadFacturePayment
                            folderId={folderData.id}
                            paymentId={payment.id}
                            onUpdate={handleFetchData}
                            prefix={prefix}
                          ></UploadFacturePayment>
                        </div>
                        {!payments[index]?.facture_file && (
                          <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                            <Icon1
                              icon_name="linked_file"
                              size={20}
                              fill={"grey"}
                            ></Icon1>
                            Pas de facture
                          </div>
                        )}
                        {payments[index]?.facture_file && (
                          <div className=" text-h4 text-wrap text-shadow_50 break-all  max-w-c200 pr-2 ">
                            {payments[index]?.facture_file?.name}
                          </div>
                        )}
                      </div>
                      {payments[index]?.facture_file && (
                        <FacturePaymentVisualisateur
                          folder={folderData}
                          payment_id={payments[index].id}
                          orgData={orgData}
                          prefix={prefix}
                        ></FacturePaymentVisualisateur>
                      )}
                    </div>
                  </div>
                  <div className="flex-grow flex flex-col gap-2  border-l-2 pl-2 border-shadow_10">
                    <div className="text-h3 text-shadow_50">
                      Rapports pour le{" "}
                      {folderData.client_type === "particulier"
                        ? "particulier"
                        : "client"}
                    </div>
                    {dropped_exists && (
                      <SecondaryButton
                        sx={{
                          backgroundColor: theme.palette.chart.line_blue,
                          color: theme.palette.forever.white,
                        }}
                        className="w-fit h-fit inset-0 shimmer rounded-2xl "
                        onClick={() =>
                          handleTransferFiles("rapport-payment#" + index)
                        }
                        disabled={
                          loadingTransfer !== undefined &&
                          loadingTransfer !== null
                        }
                      >
                        <div>
                          <div className="flex flex-row gap-1 items-center">
                            {loadingTransfer === "rapport-payment#" + index
                              ? "Transfert en cours ..."
                              : "Transférer ici"}
                            <SmallSpinner
                              loading={
                                loadingTransfer === "rapport-payment#" + index
                              }
                              margin={0}
                              size={20}
                            />
                          </div>
                        </div>
                      </SecondaryButton>
                    )}
                    <div className="flex flex-row gap-2 ">
                      <div className="flex w-8 h-fit">
                        <UploadRapportPayment
                          folder={folderData}
                          payment_id={payment.id}
                          onUpdate={handleFetchData}
                          prefix={prefix}
                        ></UploadRapportPayment>
                      </div>

                      {(!payments[index]?.rapport_files ||
                        payments[index]?.rapport_files?.length === 0) && (
                        <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                          <Icon1
                            icon_name="linked_file"
                            size={20}
                            fill={"grey"}
                          ></Icon1>
                          Pas de rapports
                        </div>
                      )}
                      {payments[index]?.rapport_files?.length > 0 && (
                        <div className=" text-h4  text-shadow_50  w-fit">
                          {payments[index]?.rapport_files?.map(
                            (file, index) => (
                              <div key={index}>
                                {file.name?.substring(0, 30)}
                              </div>
                            )
                          )}
                        </div>
                      )}
                    </div>
                    {payments[index]?.rapport_files?.length > 0 && (
                      <PaymentRapportVisualisateur
                        folder={folderData}
                        userData={userData}
                        payment_id={payments[index].id}
                        orgData={orgData}
                        prefix={prefix}
                        handleUpdate={handleFetchData}
                      ></PaymentRapportVisualisateur>
                    )}
                  </div>{" "}
                  <div className="text-h3 text-shadow_50 flex flex-row justify-end w-fit gap-1 ">
                    <div className="flex flex-col gap-1 items-end w-fit">
                      {!["initiated", "opened", "pending", "paid"].includes(
                        payments[index]?.state
                      ) && (
                        <PrimaryButton
                          className="w-fit h-fit min-w-fit"
                          disabled={
                            payments[index]?.amount <= 0 ||
                            payments[index]?.facture_file === null ||
                            payments[index]?.rapport_files?.length === 0
                          }
                          onClick={() => {
                            if (payments[index]?.amount >= 1) {
                              if (
                                index === 0 ||
                                payments[index - 1]?.state === "paid"
                              ) {
                                setPaymentOpen(index);
                              } else {
                                handleClickVariant(
                                  "Le paiement précédent n'est pas encore payé",
                                  "error"
                                );
                                return;
                              }
                            } else {
                              handleClickVariant(
                                "Le montant du paiement doit être supérieur à 1,00€",
                                "error"
                              );
                              return;
                            }
                          }}
                        >
                          {payments[index]?.state === "error"
                            ? "Initier à nouveau"
                            : "Initier paiement"}
                        </PrimaryButton>
                      )}{" "}
                      {payments[index]?.state === "error" && (
                        <Tippy
                          content={getBridgeRejectionStatusExplanation(
                            payments[index]?.bridge?.status_reason
                          )}
                          placement="top"
                          delay={100}
                          className="custom-tooltip"
                        >
                          <div className="flex flex-row gap-1 items-center w-full justify-end ">
                            <div className="font-semibold text-red-400">
                              Rejeté
                            </div>
                            <Icon1
                              icon_name="warning"
                              size={18}
                              fill={"#eb1d20"}
                            ></Icon1>
                          </div>
                        </Tippy>
                      )}
                      {payments[index]?.state === "paid" && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-green-400">
                            Payé
                          </div>
                          <Icon1
                            icon_name="done2"
                            size={18}
                            fill={"#4ade80"}
                          ></Icon1>
                        </div>
                      )}{" "}
                      {payments[index]?.downloaded === true && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-green-400 ">
                            Reçu
                          </div>
                          <Icon1
                            icon_name="done2"
                            size={18}
                            fill={"#4ade80"}
                          ></Icon1>
                        </div>
                      )}
                      {["initiated", "opened", "pending"].includes(
                        payments[index]?.state
                      ) && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-orange-500">
                            En attente
                          </div>
                          <Icon1
                            icon_name="horloge"
                            size={18}
                            fill={"#f97316"}
                          ></Icon1>
                        </div>
                      )}{" "}
                      {payments[index]?.state !== "paid" && (
                        <div className="mt-auto">
                          <SecondaryButton
                            onClick={() => setDeleteOpen(index)}
                            className={"w-fit h-fit"}
                          >
                            Supprimer
                          </SecondaryButton>{" "}
                        </div>
                      )}{" "}
                    </div>{" "}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Space y={2} />
        <div className="flex flex-row gap-2 relative z-20">
          <PrimaryButton
            startIcon={<Icon1 icon_name="plus" size={17} fill={"white"} />}
            className="w-fit "
            onClick={handleAddPayment}
          >
            Ajouter un paiement
          </PrimaryButton>
          {true && (
            <SecondaryButton
              className="w-fit "
              onClick={handleSetReglementDone}
            >
              Passer le dossier en{" "}
              {folderData.reglement_state === "done"
                ? "non finalisé"
                : "finalisé"}
            </SecondaryButton>
          )}
        </div>
      </div>{" "}
    </div>
  );
};

export default ReglementFolder;
export function getBridgeRejectionStatusExplanation(statusReason = "NOAS") {
  const explanations = {
    AC01: "Numéro de compte incorrect ou inexistant.",
    AC04: "Compte clôturé, il ne peut pas être utilisé.",
    AC06: "Compte bloqué, il ne peut pas être utilisé.",
    AG01: "Transaction interdite sur ce type de compte. Exemple : Caisse d'Épargne rejette les paiements inférieurs à 1€ avec ce motif.",
    AM18: "Nombre de transactions dépassant la limite d'acceptation de la banque.",
    CH03: "Date d'exécution demandée trop éloignée dans le futur.",
    CUST: "Rejet demandé par le client (refus ou fonds insuffisants).",
    DS02: "Ordre annulé par un utilisateur autorisé.",
    FF01: "Format de fichier invalide (erreur dans la requête de paiement : syntaxe, structure ou valeurs).",
    FRAD: "Demande de paiement considérée comme frauduleuse.",
    MS03: "Raison non spécifiée par la banque.",
    NOAS: "Aucune réponse du client, le délai a expiré.",
    RR01: "Compte débiteur ou identifiant manquant/incohérent.",
    RR03: "Nom ou adresse du créancier manquant ou insuffisant.",
    RR04: "Rejet pour raison réglementaire.",
    RR12: "Identifiant de partie invalide ou manquant (selon le pays ou type de paiement).",
    null: "Rejet sans raison précisée (aucun 'status_reason' retourné).",
  };

  return explanations[statusReason] || "Code de rejet inconnu.";
}
